module.exports = __webpack_public_path__ + "static/media/text.1d2c2f93.svg";